"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.VStack = void 0;
var _react = _interopRequireWildcard(require("react"));
var _cdsCommon = require("@cbhq/cds-common");
var _gap = require("../styles/gap");
var _linaria = require("../utils/linaria");
var _Box = require("./Box");
var _Spacer = require("./Spacer");
const _excluded = ["as", "children", "gap", "style", "className", "spacingStart", "spacerGap"];
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
const a11yStyleOverrides = {
  marginTop: 0,
  marginBottom: 0
};
const VStack = /*#__PURE__*/(0, _react.memo)( /*#__PURE__*/(0, _react.forwardRef)(function VStack(_ref, forwardedRef) {
  let as = _ref.as,
    children = _ref.children,
    gapProp = _ref.gap,
    style = _ref.style,
    className = _ref.className,
    spacingStart = _ref.spacingStart,
    spacerGap = _ref.spacerGap,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  const styles = as === 'ul' ? Object.assign({}, a11yStyleOverrides, style) : style;
  const spacingStartValue = as === 'ul' && !spacingStart ? 0 : spacingStart;
  const content = (0, _react.useMemo)(() => spacerGap && !gapProp ? (0, _cdsCommon.join)(_react.Children.toArray(children), /*#__PURE__*/_react.default.createElement(_Spacer.Spacer, {
    as: as === 'ul' || as === 'ol' ? 'li' : 'span',
    vertical: spacerGap
  })) : children, [as, children, gapProp, spacerGap]);
  return /*#__PURE__*/_react.default.createElement(_Box.Box, _extends({}, props, {
    ref: forwardedRef,
    as: as,
    className: (0, _linaria.cx)(gapProp ? _gap.gap[gapProp] : null, className),
    flexDirection: "column",
    spacingStart: spacingStartValue,
    style: styles
  }), content);
}));
exports.VStack = VStack;